import { Link } from "react-router-dom";
import { ShoppingCart, Eye } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const ProductCard = ({ product }) => {
  const { addToCart } = useApp();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const success = await addToCart(product.id);
    if (success) {
      toast.success(`${product.name} added to cart!`);
    } else {
      toast.error("Failed to add to cart");
    }
  };

  const discount = product.original_price 
    ? Math.round(((product.original_price - product.price) / product.original_price) * 100)
    : 0;

  return (
    <div className="product-card group" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.slug}`}>
        {/* Image */}
        <div className="image-container aspect-[4/5] bg-muted mb-3">
          <img
            src={product.images?.[0] || "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=500"}
            alt={product.name}
            className="product-image"
            loading="lazy"
          />
          {discount > 0 && (
            <span className="sale-badge" data-testid="sale-badge">
              {discount}% OFF
            </span>
          )}
          {product.stock <= 0 && (
            <div className="out-of-stock-overlay">
              <span className="out-of-stock-text">Out of Stock</span>
            </div>
          )}
          
          {/* Hover Actions */}
          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
            <Button 
              size="icon" 
              className="bg-white text-foreground hover:bg-primary hover:text-white"
              data-testid={`quick-view-${product.id}`}
            >
              <Eye className="w-4 h-4" />
            </Button>
          </div>
        </div>

        {/* Info */}
        <div className="space-y-2">
          <p className="bazaar-badge text-muted-foreground">{product.category_name}</p>
          <h3 className="font-medium text-foreground line-clamp-2 group-hover:text-primary transition-colors" data-testid={`product-name-${product.id}`}>
            {product.name}
          </h3>
          
          {/* Price */}
          <div className="flex items-center gap-2">
            <span className="price-current text-lg" data-testid={`product-price-${product.id}`}>
              ₹{product.price.toLocaleString()}
            </span>
            {product.original_price && (
              <span className="price-original">
                ₹{product.original_price.toLocaleString()}
              </span>
            )}
          </div>
        </div>
      </Link>

      {/* Add to Cart */}
      <Button
        onClick={handleAddToCart}
        disabled={product.stock <= 0}
        className="w-full mt-3 btn-primary"
        data-testid={`add-to-cart-${product.id}`}
      >
        <ShoppingCart className="w-4 h-4 mr-2" />
        Add to Cart
      </Button>
    </div>
  );
};

export default ProductCard;
